<template>
  <v-data-table
    :headers="headers"
    :items="pickingList"
    class="elevation-1"
    :loading="isLoading"
  >
    <template v-slot:top>
      <v-toolbar
        flat
      >
        <v-btn
          color="success"
          data-cy="PickingList-button-new"
          @click="$router.push({
            name: 'shop-EditPickingList'
          })"
        >
          <v-icon class="mr-2">
            {{ mdiPlus }}
          </v-icon>
          {{ $t('common.buttons.new') }}
        </v-btn>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <TableBasicButtons :editLink="{
          name: 'shop-EditPickingList',
          query: {id: item.id}
        }"
        @delete="remove(item)"
      />
    </template>
  </v-data-table>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { mdiPlus } from '@mdi/js';
import TableBasicButtons from '@codehq/aurora-app-core/src/components/TableBasicButtons.vue';
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'ListPickingList',
  module: 'Shop',
  components: {
    TableBasicButtons,
  },
  mixins: [loading],
  data() {
    return {
      /**
      * Icons
      */
      mdiPlus,
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('pickingList', ['pickingList']),
    /**
    * Get table column headers
    */
    headers() {
      return [
        {
          text: this.$$t('started'),
          value: 'started',
        },
        {
          text: this.$$t('completed'),
          value: 'completed',
        },
        {
          text: this.$$t('orderId'),
          value: 'orderId',
        },
        {
          text: '',
          value: 'actions',
        },
      ];
    },
  },
  async mounted() {
    this.isLoading = true;
    await this.LOAD_pickingList();
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('pickingList', ['LOAD_pickingList', 'DELETE_pickingList']),
    /** Delete PickingList from the collection
     */
    async remove(pickingList) {
      this.isLoading = true;
      await this.DELETE_pickingList(pickingList.id);
      this.isLoading = false;
    },
  },
};
</script>

<docs>
# PickingList example

'''js
<PickingList />
'''
</docs>
